import { SET_LOADER, CLEAR_STORAGE } from "actions/ui";
import { API_SUCCESS, API_ERROR } from "actions/api";
import { LOGOUT } from "actions/auth";
import { getCookie, setCookie, expireCookie, removeCookie } from 'redux-cookie';
import { USER_API_ERROR, USER_API_SUCCESS } from "../../actions/api";

// localStorage - This will persist even after the browser is closed and reopened. User will have to delete it.
// sessionStorage - This will persist till the tab and url is open will not work for new tab.
//

export default (

  state = {

    isAuthUser: localStorage.getItem("Registered") || false,
    role: localStorage.getItem("Role") || {},
    roleId: localStorage.getItem("RoleId") || {},
    userid: localStorage.getItem("UserId") || {},
    email: localStorage.getItem("Email") || {},
    // organizationName: localStorage.getItem("Organization") || "Wohler",
    firstName: localStorage.getItem("FirstName") || "Hello",
    lastName: localStorage.getItem("LastName") || {},

    isActive: localStorage.getItem("Active") || false,
    accessToken: localStorage.getItem("Token") || {},
    lastAccessTime: localStorage.getItem("LastAccessTime") || {},
    isLoading: false,
    isError: false,
    isSuccess: false,
    successMsg: {},
    error: null,
    isSsoLogoutRequested: false,
    // features: localStorage.getItem("Features") || {},
    // notificationTopics: localStorage.getItem("NotificationTopics") || [],
  },
  action
) => {
  const responseDataObj = action.payload;
  console.log("responseDataObj: ------------>", responseDataObj);

  switch (action.type) {
    case API_SUCCESS:

      //localStorage.setItem("ErrorMessage", responseDataObj.message);
      sessionStorage.setItem("ErrorMessage", responseDataObj.message);

      //Handled situation for Logout where payload won't be sent.
      if (responseDataObj.hasOwnProperty("payload")) {
        let obj = responseDataObj.payload;

        console.log("response from logout api when payload", obj);
        
        if (obj && (typeof obj !== 'undefined') && (Object.keys(obj).length !== 0)) {
          //  console.log("This has payload.");

          if ((responseDataObj.status == 'logout successful')) {

            console.log("logout response = ", responseDataObj.payload);
            let sso_logout_resquested = false;
            if (responseDataObj.payload.ssouser == true) {
              const logout_endpoint = localStorage.getItem('ssoLogoutEndpoint');
              const id_token = obj.id_token;
              if (obj.auth_provider == 'AzureAD') {
                window.location.href = `${logout_endpoint}?post_logout_redirect_uri=${window.location.origin}`;
                sso_logout_resquested = true;
              } else {
                if (id_token) {
                  window.location.href = `${logout_endpoint}?id_token_hint=${id_token}&post_logout_redirect_uri=${window.location.origin}`;
                  sso_logout_resquested = true;
                }
              }
            }

            localStorage.removeItem("Role");
            localStorage.removeItem("RoleId");
            localStorage.removeItem("UserId");
            localStorage.removeItem("CustomerId");
            localStorage.removeItem("Organization");
            localStorage.removeItem("FirstName");
            localStorage.removeItem("LastName");
            localStorage.removeItem("Token");
            localStorage.removeItem("Registered");
            localStorage.removeItem("LastAccessTime");
            localStorage.removeItem("Features");
            localStorage.removeItem("NotificationTopics");
            localStorage.removeItem("ssoLogoutEndpoint");
            localStorage.removeItem("isSsoUser");
            localStorage.removeItem("ssoLoginRequested");

            removeCookie('RoleCookie', { path: '/' });

            return {
              ...state,
              isSsoLogoutRequested: sso_logout_resquested,
              isAuthUser: false,
              role: {},
              roleId: {},
              userid: {},
              // customerId: {},
              // organizationName: "Wohler",
              firstName: {},
              lastName: {},
              accessToken: {},
              lastAccessTime: {}, isError: false, isSuccess: true, successMsg: {}, 
              // features: {}, notificationTopics: []
            };
          }

        } else {
          localStorage.removeItem("Role");
          localStorage.removeItem("RoleId");
          localStorage.removeItem("UserId");
          localStorage.removeItem("Email");
          localStorage.removeItem("FirstName");
          localStorage.removeItem("LastName");
          localStorage.removeItem("Token");
          localStorage.removeItem("Registered");
          localStorage.removeItem("LastAccessTime");
          localStorage.removeItem("ssoLogoutEndpoint");
          localStorage.removeItem("isSsoUser");
          localStorage.removeItem("ssoLoginRequested");

          removeCookie('RoleCookie', { path: '/' });
          return {
            ...state,
            isAuthUser: false,
            role: {},
            roleId: {},
            userid: {},
            email: {},
            firstName: {},
            lastName: {},
            accessToken: {},
            lastAccessTime: {},
            error: responseDataObj.message, isError: false, isSuccess: true, successMsg: {}
            // features: {}, notificationTopics: []
          };
        }
      }

      //Check if authenticated. When the user logs in.
      if (responseDataObj.payload.hasOwnProperty("authenticated")) {
        if (responseDataObj.payload.authenticated === true) {
          console.log("Role : ", responseDataObj.payload);
          console.log("SsoUser = ", responseDataObj.payload.ssouser);
          // console.log("UserId : ", responseDataObj.payload.user_token.user_id);
          //console.log("cookieRole : ", cookieRole);

          localStorage.setItem("Role", responseDataObj.payload.user_token.role);
          localStorage.setItem("RoleId", parseInt(responseDataObj.payload.user_token.role_id));
          localStorage.setItem("UserId", parseInt(responseDataObj.payload.user_token.user_id));
          localStorage.setItem("Email", responseDataObj.payload.user_token.email);
          // localStorage.setItem("Organization", responseDataObj.payload.user_token.org_name);
          localStorage.setItem("FirstName", responseDataObj.payload.user_token.first_name);
          localStorage.setItem("LastName", responseDataObj.payload.user_token.last_name);
          localStorage.setItem("Token", responseDataObj.payload.access_token.token);
          localStorage.setItem("Registered", responseDataObj.payload.authenticated);
          localStorage.setItem("LastAccessTime", responseDataObj.payload.user_token.last_access_time);
          localStorage.setItem("isSsoUser", responseDataObj.payload.ssouser);
          // localStorage.setItem("Features", JSON.stringify(responseDataObj.payload.entitlements.features));
          // localStorage.setItem("NotificationTopics", responseDataObj.payload.access_token.notification_topics);

          return {
            ...state,
            isAuthUser: true,
            role: responseDataObj.payload.user_token.role,
            roleId: parseInt(responseDataObj.payload.user_token.role_id),
            userid: parseInt(responseDataObj.payload.user_token.user_id),
            // customerId:parseInt(responseDataObj.payload.user_token.customer_id),
            email: responseDataObj.payload.user_token.email,
            firstName: responseDataObj.payload.user_token.first_name,
            lastName: responseDataObj.payload.user_token.last_name,
            accessToken: responseDataObj.payload.access_token.token,
            lastAccessTime: responseDataObj.payload.user_token.last_access_time,
            isError: false, isSuccess: true, successMsg: {},
            isSsoUser: responseDataObj.payload.ssouser
            // features: responseDataObj.payload.entitlements.features,
            // notificationTopics: responseDataObj.payload.access_token.notification_topics
          };
        } else {

          localStorage.removeItem("Role");
          localStorage.removeItem("RoleId");
          localStorage.removeItem("UserId");
          localStorage.removeItem("Email");
          // localStorage.removeItem("Organization");     
          localStorage.removeItem("FirstName");
          localStorage.removeItem("LastName");
          localStorage.removeItem("Token");
          localStorage.removeItem("Registered");
          localStorage.removeItem("LastAccessTime");
          localStorage.removeItem("ssoLogoutEndpoint");
          localStorage.removeItem("isSsoUser");
          localStorage.removeItem("ssoLoginRequested");
          // localStorage.removeItem("Features");
          // localStorage.removeItem("NotificationTopics");

          removeCookie('RoleCookie', { path: '/' });
          return {
            ...state,
            isAuthUser: false,
            role: {},
            roleId: {},
            email: {},
            // organizationName:"Wohler", 
            firstName: {},
            lastName: {},
            accessToken: {},
            lastAccessTime: {},
            error: responseDataObj.message, isError: true, isSuccess: false, successMsg: {}
            // features: {}, notificationTopics: []
          };
        }
      }


    case API_ERROR:
      console.log("reducer.js API_ERROR : ", action.payload);
      return { ...state, error: action.payload, isError: true, isSuccess: false, successMsg: {} };
    // features: {}, notificationTopics: [] };
    case SET_LOADER:
      return { ...state, isLoading: action.payload, isSuccess: false, successMsg: {} };
    // return { ...state, isLoading: action.payload,isSuccess:false,successMsg: {}, features: {}, notificationTopics: [] };
    case CLEAR_STORAGE:
      console.log("Clearing Storage : ", action.payload)
      if (action.payload === true) {
        localStorage.removeItem("Role");
        localStorage.removeItem("RoleId");
        localStorage.removeItem("UserId");
        localStorage.removeItem("Token");
        localStorage.removeItem("Registered");
        localStorage.removeItem("Email");
        // localStorage.removeItem("Organization");   
        localStorage.removeItem("FirstName");
        localStorage.removeItem("LastName");
        localStorage.removeItem("LastAccessTime");
        localStorage.removeItem("ssoLogoutEndpoint");
        localStorage.removeItem("isSsoUser");
        localStorage.removeItem("ssoLoginRequested");
        // localStorage.removeItem("Features");
        // localStorage.removeItem("NotificationTopics");

        removeCookie('RoleCookie', { path: '/' });
        return {
          ...state,
          isAuthUser: false,
          role: {},
          roleId: {},
          userid: {},
          email: {},
          // organizationName:"Wohler", 
          firstName: {},
          lastName: {},
          accessToken: {},
          lastAccessTime: {}, isError: false, isSuccess: false, successMsg: {}
          // features: {}, 
          // notificationTopics: [] 
        };
      }
      return { ...state, error: action.payload };
    case LOGOUT:
      {

        localStorage.removeItem("Role");
        localStorage.removeItem("RoleId");
        localStorage.removeItem("UserId");
        localStorage.removeItem("Email");
        // localStorage.removeItem("Organization"); 
        localStorage.removeItem("FirstName");
        localStorage.removeItem("LastName");
        localStorage.removeItem("Token");
        localStorage.removeItem("Registered");
        localStorage.removeItem("LastAccessTime");
        localStorage.removeItem("isSsoUser");
        localStorage.removeItem("ssoLoginRequested");
        // localStorage.removeItem("Features");
        // localStorage.removeItem("NotificationTopics");

        removeCookie('RoleCookie', { path: '/' });
        return {
          ...state,
          isAuthUser: false,
          role: {},
          roleId: {},
          userid: {},
          email: {},
          // organizationName:"Wohler", 
          firstName: {},
          lastName: {},
          accessToken: {},
          lastAccessTime: {}, isError: false, isSuccess: false, successMsg: {}
          // features: {}, notificationTopics: [] 
        };
      }
    case USER_API_SUCCESS:
      {
        console.log("USER_API_SUCCESS Response Data ", action.payload);
        if (responseDataObj && (typeof responseDataObj !== 'undefined') && (Object.keys(responseDataObj).length !== 0)) {

        }

        return {
          ...state, error: responseDataObj.message, isError: false, isSuccess: true, successMsg: responseDataObj.message
          // features: responseDataObj.payload.entitlements.features, 
          // notificationTopics: responseDataObj.payload.access_token.notification_topics 
        };
      }
    case USER_API_ERROR:
    default:
      return state;
  }
};
